const VistaUsuariosMiPerfil = () => import('Modules/administracion/usuarios/views/UsuariosMiPerfil')
const VistaUsuariosAbmDetalle = () =>
  import('Modules/administracion/usuarios/views/UsuariosAbmDetalle')
const VistaUsuariosAbm = () => import('Modules/administracion/usuarios/views/UsuariosAbm')
const VistaPermisosAbm = () => import('Modules/administracion/permisos/views/PermisosAbm')
const VistaRolesAbm = () => import('Modules/administracion/roles/views/RolesAbm')
const VistaTipoEntidadesAbm = () =>
  import('Modules/administracion/entidades/views/TipoEntidades/TipoEntidadesAbm')
const VistaEntidadesAbm = () =>
  import('Modules/administracion/entidades/views/Entidades/EntidadesAbm')

const VistaInstitucionesAbmDetalle = () =>
  import('Modules/administracion/instituciones/views/InstitucionesAbmDetalle')
const VistaInstitucionesAbm = () =>
  import('Modules/administracion/instituciones/views/InstitucionesAbm')

const VistaObrasSocialesAbm = () =>
  import('Modules/administracion/obrasSociales/views/ObrasSociales/ObrasSocialesAbm')
const VistaObrasSocialesAbmDetalle = () =>
  import('Modules/administracion/obrasSociales/views/ObrasSociales/ObrasSocialesAbmDetalle')

const VistaNotificacionesAbm = () =>
  import('Modules/administracion/notificaciones/views/NotificacionesAbm')

const VistaPracticasAbm = () => import('Modules/administracion/practicas/views/PracticasAbm')

const VistaDiasNoLaborablesAbm = () => import('Modules/administracion/diasNoLaborables/views/DiasNoLaborablesAbm')

const rutas = [
  {
    name: 'usuarios',
    component: VistaUsuariosAbm,
    path: '/administracion/usuarios',
    props: {
      componente: 'listado'
    },
    meta: {
      requiresAuth: true,
      title: 'Listado de usuarios',
      breadcrumb: null,
      menu: 'administracion'
    }
  },
  {
    name: 'usuarios:modificar',
    component: VistaUsuariosAbmDetalle,
    path: '/administracion/usuarios/modificar/:id',
    props: {
      titulo: 'Modificar',
      operacion: 'modif'
    },
    meta: {
      requiresAuth: true,
      title: 'Modificar usuario',
      breadcrumb: null,
      menu: 'administracion'
    }
  },
  {
    name: 'usuarios:ver',
    component: VistaUsuariosAbmDetalle,
    path: '/administracion/usuarios/ver/:id',
    props: {
      titulo: 'Ver',
      operacion: 'lectura'
    },
    meta: {
      requiresAuth: true,
      title: 'Ver usuario',
      breadcrumb: null,
      menu: 'administracion'
    }
  },
  {
    component: VistaPermisosAbm,
    path: '/administracion/permisos',
    meta: {
      requiresAuth: true,
      title: 'Listado de permisos',
      breadcrumb: null,
      menu: 'administracion'
    }
  },
  {
    component: VistaRolesAbm,
    path: '/administracion/roles',
    meta: {
      requiresAuth: true,
      title: 'Listado de roles',
      breadcrumb: null,
      menu: 'administracion'
    }
  },
  {
    name: 'mi-perfil',
    component: VistaUsuariosMiPerfil,
    path: '/perfil',
    meta: {
      requiresAuth: true,
      title: 'Mi perfil',
      breadcrumb: null
    }
  },
  {
    component: VistaTipoEntidadesAbm,
    path: '/administracion/tipo-entidades',
    meta: {
      requiresAuth: true,
      title: 'Listado de tipo de entidades',
      breadcrumb: null,
      menu: 'administracion'
    }
  },
  {
    name: 'entidades:listar',
    component: VistaEntidadesAbm,
    path: '/administracion/entidades/:id/:slug',
    meta: {
      requiresAuth: true,
      title: 'Listado de entidades',
      breadcrumb: null,
      menu: 'administracion'
    }
  },
  {
    name: 'instituciones',
    component: VistaInstitucionesAbm,
    path: '/administracion/instituciones',
    props: {
      componente: 'listado'
    },
    meta: {
      requiresAuth: true,
      title: 'Listado de instituciones',
      breadcrumb: null,
      menu: 'administracion'
    }
  },
  {
    name: 'instituciones:modificar',
    component: VistaInstitucionesAbm,
    path: '/administracion/instituciones/modificar/:id',
    props: {
      titulo: 'Modificar',
      operacion: 'modif'
    },
    meta: {
      requiresAuth: true,
      title: 'Modificar',
      breadcrumb: null,
      menu: 'administracion'
    }
  },
  {
    name: 'instituciones:ver',
    component: VistaInstitucionesAbmDetalle,
    path: '/administracion/instituciones/ver/:id',
    props: {
      titulo: 'Ver',
      operacion: 'lectura'
    },
    meta: {
      requiresAuth: true,
      title: 'Ver',
      breadcrumb: null,
      menu: 'administracion'
    }
  },
  /* {
    name: 'obras_sociales:listar',
    component: VistaObrasSocialesAbm,
    path: '/administracion/obras-sociales',
    meta: {
      requiresAuth: true,
      title: 'Listado de obras sociales',
      breadcrumb: null,
      menu: 'administracion'
    }
  }, */
  {
    name: 'obras-sociales',
    component: VistaObrasSocialesAbm,
    path: '/administracion/obras-sociales',
    props: {
      componente: 'listado'
    },
    meta: {
      requiresAuth: true,
      title: 'Listado de obras sociales',
      breadcrumb: null,
      menu: 'administracion'
    }
  },
  {
    name: 'obras-sociales:ver',
    component: VistaObrasSocialesAbmDetalle,
    path: '/administracion/obras-sociales/ver/:id',
    props: {
      titulo: 'Ver',
      operacion: 'lectura'
    },
    meta: {
      requiresAuth: true,
      title: 'Ver',
      breadcrumb: null,
      menu: 'administracion'
    }
  },
  {
    component: VistaDiasNoLaborablesAbm,
    path: '/administracion/dias-no-laborables',
    meta: {
      requiresAuth: true,
      title: 'Listado de días no laborables',
      breadcrumb: null,
      menu: 'administracion'
    }
  },
  {
    name: 'notificaciones',
    component: VistaNotificacionesAbm,
    path: '/administracion/notificaciones',
    props: {
      componente: 'listado'
    },
    meta: {
      requiresAuth: true,
      title: 'Listado de notificaciones',
      breadcrumb: null
    }
  },
  {
    component: VistaPracticasAbm,
    path: '/administracion/practicas',
    meta: {
      requiresAuth: true,
      title: 'Listado de practicas',
      breadcrumb: null,
      menu: 'administracion'
    }
  }
]

export default rutas
